module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/gall_bladder-b11d5888e626434a900afd9cbd662194.png";